import { useUser } from '@mentimeter/user';
import { useCallback } from 'react';
import type { SignupModeEnum } from '@mentimeter/http-clients';
import { useMutateWorkspaceById, useWorkspaceById } from './useWorkspaceById';
import { SSO_SIGNUPMODES } from './constants';

export const useCurrentUserWorkspace = () =>
  useWorkspaceById(useUser().user?.workspaceId);

export function useInvalidateCurrentUserWorkspace() {
  const workspaceId = useUser().user?.workspaceId;
  const invalidateWorkspaceById = useMutateWorkspaceById();
  return useCallback(() => {
    if (!workspaceId) return;
    return invalidateWorkspaceById(workspaceId);
  }, [workspaceId, invalidateWorkspaceById]);
}

export const useUsesSso = () =>
  SSO_SIGNUPMODES.includes(
    useCurrentUserWorkspace().data?.signupMode as SignupModeEnum,
  );
